import ItemAction from '../../model/interactive/actions/ItemAction';
import GoToPageAction from '../../model/interactive/actions/GoToPageAction';
import HideItemAction from '../../model/interactive/actions/HideItemAction';
import ShowItemAction from '../../model/interactive/actions/ShowItemAction';
import OpenWebAction from '../../model/interactive/actions/OpenWebAction';
import PlayAudioAction from '../../model/interactive/actions/PlayAudioAction';
import PauseAudioAction from '../../model/interactive/actions/PauseAudioAction';
import ResumeAudioAction from '../../model/interactive/actions/ResumeAudioAction';
import StopAudioAction from '../../model/interactive/actions/StopAudioAction';
import PlayMovieAction from '../../model/interactive/actions/PlayMovieAction';
import PauseMovieAction from '../../model/interactive/actions/PauseMovieAction';
import ResumeMovieAction from '../../model/interactive/actions/ResumeMovieAction';
import StopMovieAction from '../../model/interactive/actions/StopMovieAction';
import ToggleMenuAction from '../../model/interactive/actions/ToggleMenuAction';
import ExitCatalogAction from '../../model/interactive/actions/ExitCatalogAction';
import GoToStateAction from '../../model/interactive/actions/GoToStateAction';
import GoToNextStateAction from '../../model/interactive/actions/GoToNextStateAction';
import GoToPreviousStateAction from '../../model/interactive/actions/GoToPreviousStateAction';
import OpenCatalogAction from '../../model/interactive/actions/OpenCatalogAction';

export default class ItemActionParser {

    static parse(node) {
        let itemAction = new ItemAction();

        let type = node.attr('xsi:type');
        switch (type) {
            case 'ns2:GoToPageAction':
                itemAction = new GoToPageAction();
                itemAction.page = parseInt(node.children('ns2\\:page').text());
                break;
            case 'ns2:HideItemAction':
                itemAction = new HideItemAction();
                itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                break;
            case 'ns2:ShowItemAction':
                itemAction = new ShowItemAction();
                itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                break;
            case 'ns2:OpenWebAction':
                itemAction = new OpenWebAction();
                itemAction.url = node.children('ns2\\:url').text();
                itemAction.title = node.children('ns2\\:title').text();
                itemAction.openOutside = (node.children('ns2\\:openOutside').text() == 'true');
                break;
            case 'ns2:PlayAudioAction':
                itemAction = new PlayAudioAction();
                itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                break;
            case 'ns2:PauseAudioAction':
                itemAction = new PauseAudioAction();
                itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                break;
            case 'ns2:ResumeAudioAction':
                itemAction = new ResumeAudioAction();
                itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                break;
            case 'ns2:StopAudioAction':
                itemAction = new StopAudioAction();
                itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                break;
            case 'ns2:PlayMovieAction':
                itemAction = new PlayMovieAction();
                itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                break;
            case 'ns2:PauseMovieAction':
                itemAction = new PauseMovieAction();
                itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                break;
            case 'ns2:ResumeMovieAction':
                itemAction = new ResumeMovieAction();
                itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                break;
            case 'ns2:StopMovieAction':
                itemAction = new StopMovieAction();
                itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                break;
            case 'ns2:ToggleMenuAction':
                itemAction = new ToggleMenuAction();
                break;
            case 'ns2:ExitCatalogAction':
                itemAction = new ExitCatalogAction();
                break;
            case 'ns2:GoToStateAction':
                itemAction = new GoToStateAction();
                itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                itemAction.stateName = parseInt(node.children('ns2\\:stateName').text());
                break;
            case 'ns2:GoToNextStateAction':
                itemAction = new GoToNextStateAction();
                itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                itemAction.stopInLast = (node.children('ns2\\:stopInLast').text() == 'true');
                break;
            case 'ns2:GoToPreviousStateAction':
                itemAction = new GoToPreviousStateAction();
                itemAction.itemId = parseInt(node.children('ns2\\:itemId').text());
                itemAction.stopInFirst = (node.children('ns2\\:stopInFirst').text() == 'true');
                break;
            case 'ns2:OpenCatalogAction':
                itemAction = new OpenCatalogAction();
                itemAction.catalogId = node.children('ns2\\:catalogId').text();
                break;
        }

        itemAction.animationType = node.children('ns2\\:animationType').text();
        itemAction.animationDuration = parseFloat(node.children('ns2\\:animationDuration').text());
        itemAction.animationRepeat = (node.children('ns2\\:animationRepeat').text() == 'true');

        return itemAction;
    }

}
